import script from "./TourBooking.vue?vue&type=script&setup=true&lang=js"
export * from "./TourBooking.vue?vue&type=script&setup=true&lang=js"

import "./TourBooking.vue?vue&type=style&index=0&id=0e2c7a47&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e2c7a47"]])

export default __exports__